import { GameManager } from "../../GameManager";
import { Background } from "../Background";
import { LowerMenu } from "../LowerMenu";
import { BoardContainer } from "../board-scene/BoardContainer";
import { TutorialManager } from "./TutorialManager";
import { Game } from "../../Game";
import { GUI } from "../board-scene/gui/GUI";
import { TutorialMessagesLayer } from "./TutorialMessagesLayer";
import { GameVars } from "../../GameVars";

export class TutorialScene extends Phaser.Scene {

    public static currentInstance: TutorialScene;

    public tutorialManager: TutorialManager;

    private boardContainer: BoardContainer;
    private gui: GUI;
    private lowerMenu: LowerMenu;
    private tutorialMessagesLayer: TutorialMessagesLayer;

    constructor() {

        super("TutorialScene");
    }

    public create(): void {

        GameManager.setCurrentScene(this); 

        TutorialScene.currentInstance = this;
        
        this.tutorialManager = new TutorialManager();

        this.anims.create({ 
            key: "arrow", 
            frames: this.anims.generateFrameNames( "texture_atlas_1", {prefix: "arrowVFX_", start: 1, end: 16, zeroPad: 2, suffix: ""}), 
            frameRate: 24, 
            repeat: -1
        });
        
        const background = new Background(this, 1);
        this.add.existing(background);

        this.boardContainer = new BoardContainer(this);
        this.add.existing(this.boardContainer);

        this.gui = new GUI(this);
        this.gui.onTutorialStage0();
        this.add.existing(this.gui);

        this.lowerMenu = new LowerMenu(this); 
        this.add.existing(this.lowerMenu);

        this.tutorialMessagesLayer = new TutorialMessagesLayer(this);
        this.add.existing(this.tutorialMessagesLayer);
    
        if (!this.sys.game.device.os.desktop) {
            this.input.on("pointerup", function(): void {
                Game.currentInstance.launchIntoFullscreen(document.documentElement);
            }, this);
        }
    }

    public update(): void {

        this.tutorialManager.update();

        this.boardContainer.update();
        this.gui.update();
    }

    public onTutorialStage1(): void {

        this.gui.onTutorialStage1();
        this.tutorialMessagesLayer.onTutorialStage1();
    }

    public onTutorialStage2(): void {

        this.gui.onTutorialStage2();
    }

    public onTutorialStage3(): void {

        this.boardContainer.onTutorialStage3();
        this.gui.onTutorialStage3();
        this.tutorialMessagesLayer.onTutorialStage3();
    }

    public onTutorialStage4(): void {

        this.gui.onTutorialStage4();
    }

    public onTutorialStart(): void {

        this.onNewTurn(true);
        this.boardContainer.addTutorialStriker();
        this.gui.onTutorialStart();
    }

    public onNewTurn(firstTurn?: boolean): void {

        this.boardContainer.onNewTurn(firstTurn);
        this.gui.onNewTurn();
    }

    public onShot(): void {
        
        this.gui.onShot();
        this.tutorialMessagesLayer.onShot();
    }

    public onTutorialCompleted(): void {

        this.boardContainer.onTutorialTurnCompleted();
        this.tutorialMessagesLayer.onTutorialTurnCompleted();
    }
}
